import { AnalyticsBrowser } from '@segment/analytics-next';

import env from 'helpers/env';

window.segmentV2 = AnalyticsBrowser.load(
  {
    writeKey: env.segmentV2WriteKey
  },
  {
    integrations: {
      'Segment.io': {
        apiHost: 'sega.avoma.com/v1'
      }
    }
  }
);
